module.exports = __webpack_public_path__ + "img/instagram.936e9895.png";